<template>
  <p :class="['rqa_entity_text', textClass]">
    <template v-for="(seg, i) in segments">
      <a v-if="seg.entity" :key="i" href="#" class="rqa_entity_link" :class="'rqa_entity_' + seg.entity.type"
         :title="titleOf(seg.entity)" @click.prevent="open(seg.entity)"
         @mouseenter="peek(seg.entity)" @mouseleave="unpeek">{{ seg.text }}</a>
      <template v-else>{{ seg.text }}</template>
    </template>
  </p>
</template>

<script>
// Answer text rendered from the server's segments: the occurrences the server
// accepted become inline links (hover = peek modal, click = full modal, see
// openEntity.js); everything else is plain text (never v-html).
import { entityTitle } from '@/utils/recruiterQaEntities'
import openEntity from './openEntity'

export default {
  name: 'RecruiterQaEntityText',
  mixins: [openEntity],
  props: {
    segments: { type: Array, default: () => [] },
    textClass: { type: String, default: '' }
  },
  methods: {
    titleOf (entity) { return entityTitle(entity) }
  }
}
</script>

<style scoped>
.rqa_entity_text {
  white-space: pre-line;
  word-break: break-word;
}
.rqa_entity_link {
  color: #1f5fbf;
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 2px;
  cursor: pointer;
}
.rqa_entity_link:hover, .rqa_entity_link:focus {
  text-decoration-style: solid;
  outline: none;
}
</style>
